import React from "react"
const ReactDisqusThread = require('react-disqus-thread');

let window;

class BlogPostTemplate extends React.Component {

  handleNewComment(comment) {
    console.log(comment.text);
  }

  render() {
    const post = this.props.data.markdownRemark

    return (
      <div>
        <h1>{post.frontmatter.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
        <ReactDisqusThread
          shortname="blog-juha-net"
          onNewComment={this.handleNewComment} />
      </div>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
query BlogPostBySlug($slug: String!) {
  markdownRemark(fields: { slug: { eq: $slug }}) {
    html
    frontmatter {
      title
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js